module.exports = __webpack_public_path__ + "step1_child_to_parent_son.7373cdbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step1_child_to_parent_son.jpg
// module id = ksc9
// module chunks = 0